// extracted by mini-css-extract-plugin
export default {"click-out-page":"uiEErx0U5AIdUI0Wz5KV"};